<template>
    <div 
        class="bubble-menu-container"
        :class="showBubbles && 'show'"
    >
        <div class="bubble-trigger" @click="showBubbles = !showBubbles">
            <img src="~public/icons/share.svg" alt="">
        </div>

        <div
            class="bubble-menu"
        >
            <!-- Copy to Clipboard -->
            <div class="bubble bubble-1" @click="copyToClipboard" title="Link kopieren">
                <FadeInTransition>
                    <div class="copy-notice" v-if="showBubbles && showCopyNotice">
                        <span>Link&nbsp;kopiert</span>
                    </div>
                </FadeInTransition>

                <img src="~public/icons/copy.svg" alt="copy">
            </div>

            <!-- Send prepared email -->
            <!-- <div class="bubble bubble-2">
                <a 
                    :href="`mailto:?subject=${pageMeta?.title}?body=${mailBody}`"
                    title="E-Mail"
                >
                    <font-awesome-icon :icon="['far', 'envelope']" />
                </a>
            </div> -->

            <!-- Share via Whatsapp -->
            <div class="bubble bubble-3">
                <a
                    target="_blank"
                    id="whatsapp-button"
                    :href="`whatsapp://send?text=${mailBody}`"
                    title="Whatsapp"
                >
                    <font-awesome-icon :icon="['fab', 'whatsapp']" />
                </a>
            </div>

            <!-- Share via telegram -->
            <!-- <div class="bubble bubble-4">
                <a
                    target="_blank"
                    id="telegram-button"
                    :href="`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(mailBody)}`"
                    title="Telegram"
                >
                    <font-awesome-icon :icon="['fab', 'telegram']" />
                </a>
            </div> -->

            <!-- Share on Xing -->
            <div class="bubble bubble-5">
                <a
                    target="_blank"
                    id="xing-button"
                    :href="`https://www.xing.com/spi/shares/new?url=${encodeURIComponent(url)}&title=${encodeURIComponent(mailBody)}`"
                    title="Xing"
                >
                    <font-awesome-icon :icon="['fab', 'xing']" />
                </a>
            </div>

            <!-- Share on LinkedIn -->
            <div class="bubble bubble-6">
                <a
                    target="_blank"
                    id="linkedin-button"
                    :href="`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}&title=${encodeURIComponent(msgTitle)}&source=${encodeURIComponent('Walbert-Schmitz GmbH')}`"
                    title="LinkedIn"
                >
                    <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useRequestStore } from '@/stores/requests'

    const showBubbles = ref<boolean>(false)
    const showCopyNotice = ref<boolean>(false)

    const requestStore = useRequestStore()
    const { pageContent, pageID } = storeToRefs(requestStore)

    const url = window.location.href

    const pageMeta = computed(() => {
		const metaData: any = pageContent.value[pageID.value]?.pagemeta

		return metaData
	})

    const mailBody = `Ich habe einen interessanten Artikel auf www.walbert-schmitz.de gefunden, schau mal: ${url}`
    const msgTitle = `Ein interessanter Artikel, den ich gefunden habe!`

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(url)
            showCopyNotice.value = true

            setTimeout(() => {
                showCopyNotice.value = false
            },1200)
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }

    const isMobileDevice = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    onMounted(() => {
        window.addEventListener('scroll', () => {
            showBubbles.value = false
        })

        window.addEventListener('click', () => {
            showBubbles.value = false
        })

        document.querySelector('.bubble-menu-container')?.addEventListener('click', (e) => {
            e.stopPropagation()
        })

        const allBubbles = document.querySelectorAll('.bubble')

        allBubbles.forEach(bubble => {
            bubble.addEventListener('click', (e) => {
                e.stopPropagation()
            })
        })

        const whatsappButton = document.querySelector('#whatsapp-button') as HTMLAnchorElement
        const whatsappMsg = encodeURIComponent(mailBody)

        if (isMobileDevice()) {
            whatsappButton.href = `whatsapp://send?text=${whatsappMsg}`
        } else {
            whatsappButton.href = `https://web.whatsapp.com/send?text=${whatsappMsg}`
        }
    })
</script>